{
    "UploadfilesFilename": "Nome do arquivo",
    "UploadfilesFilesize": "Tamanho do arquivo",
    "UploadfilesEmailserroredsendingseebelow": "Clique para mais informações",
    "UploadfilesSuccesswitherrorparagraph": "Seus usuários foram configurados. No entanto, ocorreu um erro ao enviar e-mails de boas-vindas.",
    "Resulttableheaderusername": "Nome de usuário",
    "Resulttableheaderemail": "Endereço de email",
    "Resulttableheaderrptaccess": "Acesso a relatórios",
    "Resulttableheaderisadmin": "é administrador?",
    "Resulttableheaderisocagent": "O agente é OC?",
    "Resulttableheaderenhancemobileapp": "Aplicativo móvel aprimorado?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Usuários de upload em massa",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Importar arquivo.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Começar",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Em processamento.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Voltar",
    "LanguageBulkInsertUsers_UploadfilesButton3": "confirme",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importar.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Ops.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Confirmação.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Sucesso.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Feito",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Viva! Configuramos seus usuários com sucesso.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Comece baixando e preenchendo o",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "Modelo CSV",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "forneceu.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Confirme se tudo foi digitado corretamente e prossiga para importar o arquivo completo aqui (Quaisquer erros com o arquivo serão detectados durante a configuração):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Escolher arquivo",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": "ou arraste e solte aqui.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Solte seus arquivos aqui...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Detalhes do arquivo:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Tem certeza de que deseja fechar a janela e perder o progresso?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "sim",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Cancelar",
    "LanguageBulkInsertUsers_ValidationError": "Erro: não foi possível processar a solicitação de provisionamento em massa. Veja abaixo mais informações.",
    "LanguageBulkInsertUsers_SuccessTitle": "Verifique suas alterações e confirme.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Erro: formato de arquivo inválido, use nosso modelo CSV.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Erro: o tamanho máximo do arquivo foi excedido. Máximo de 10 MB permitidos.",
    "NAME": "LanguageBulkInsertUsers"
}